import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
// import TeamListPage from './TeamListPage';
import { Loader } from '../../../../../common/components';

const TeamListPage = loadable(() => import('./TeamListPage'), {
  fallback: <Loader />
});

const TeamRoutes = ({ t, employeeCanViewTeam, updateSelectedTab, alert }) => {
  return [
    <Route
      key="team_record_list"
      exact
      path="/team"
      element={
        <TeamListPage
          t={t}
          employeeCanViewTeam={employeeCanViewTeam}
          updateSelectedTab={updateSelectedTab}
          alert={alert}
        />
      }
    />
  ];
};
TeamRoutes.propTypes = {
  t: PropTypes.func
};
export default TeamRoutes;
